
export default class State {
  public single_auth: string;

  constructor() {
    this.single_auth = "";
  }
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/state.ts